import { IPlayerGame } from '@grassrootly/api/entities';
import { provider } from "@grassrootly/api/providers";

export interface GetPlayerPreviousGamesPayload {
  date_to: string;
  pid: number;
  limit?: number;
  offset?: number;
}

export const GetPlayerPreviousGames = async (params: GetPlayerPreviousGamesPayload): Promise<IPlayerGame[]> =>
  provider.Request("/previous-games", params);
